import { Source } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export const VersionSourceIcon = (props: SvgIconProps) => (<Source {...props}/>);